<template>
  <div class="carousel" :class="{ 'has-caption': isShow }">
    <el-carousel
        :height="Number(height) + 'px'"
        :loop="true"
        :interval="interval"
        trigger="click"
        arrow="always"
        :autoplay="isShow ? true : false"
    >
      <el-carousel-item
          class="image"
          v-for="item in images"
          :key="item.id"
      >
        <a
            v-if="item.linkUrl"
            :href="item.linkUrl"
            class="banner-link"
            target="_blank"
            rel="noopener"
        >
          <img
              :src="prodUrl+item.homePicture"
              :width="widthImage + '%'"
              :height="heightImage + '%'"
              alt="无图片"
          >
        </a>
        <img
            v-else
            :src="prodUrl+item.homePicture"
            :width="widthImage + '%'"
            :height="heightImage + '%'"
            alt="无图片"
        >
        <div class="ImageSpan" v-if="isShow" >
          <div>{{item.chineseTitle}}</div>
        </div>

      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prodUrl:"https://shujuzichan.com/xwzx"
      // aaa: 1
    };
  },
  props: {
    // 轮播图路径数组
    images: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    // 轮播图宽度
    width: {
      type: Number,
      default: 0,
    },
    // 轮播图高度
    height: {
      type: String,
      default: "400",
    },
    // 相邻两张图片切换的间隔时间
    interval: {
      type: Number,
      default: 5000,
    },
    //图片宽
    widthImage: {
      type: Number,
      default: 100,
    },
    //图片高
    heightImage: {
      type: Number,
      default: 100,
    },
  },
  computed:{
    aaa () {
      let scale
      // if (document.documentElement.clientWidth < 1000) {
          scale = document.documentElement.clientWidth / 1920
      // } else {
      //     scale = 1920 / 1920
      // }
      return Math.min(scale, 2)
    }
  },
  methods: {
    
  }
};
</script>

<style scoped lang="css">
.carousel {
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}
.el-carousel {
  overflow-x: hidden;
  overflow-y: hidden;
}

.el-carousel__item {
  background-color: #99a9bf;
}
::v-deep .el-carousel__indicators {
  display: none !important;
}
.image {
  height: 100%;
}
.image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.carousel.has-caption {
  border-radius: 8px;
  overflow: hidden;
}
.ImageSpan {
  margin-top: -48px;
  font-size: 22px;
  font-weight: 700;
  color: gray;
  text-align: center;
  position: absolute;
  background-color: rgb(232, 237, 238, .8);
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
  transition: background-color 0.25s ease, color 0.25s ease;
}
.carousel.has-caption:hover .ImageSpan,
.ImageSpan:hover {
  background-color: #0165FF;
  color: #fff;
}
@media (max-width: 960px) {
  .carousel {
    height: auto;
    aspect-ratio: 2.1 / 1;
    min-height: 148px;
    max-height: 220px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    border-radius: 0;
    background: #0a3d9c;
  }
  :deep(.el-carousel),
  :deep(.el-carousel__container),
  :deep(.el-carousel__item) {
    height: 100% !important;
    background: #0a3d9c;
  }
  :deep(.el-carousel__item img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
    display: block;
  }
  :deep(.el-carousel__arrow) {
    display: none;
  }
  .ImageSpan {
    font-size: 12px;
    line-height: 1.35;
    margin-top: -36px;
    padding: 6px 10px;
  }
}
.carousel.news-banner {
  border-radius: 8px;
  overflow: hidden;
}
@media (max-width: 960px) {
  .carousel.news-banner {
    aspect-ratio: 16 / 9;
    min-height: 132px;
    max-height: 180px;
    border-radius: 12px;
    background: #edf3ff;
  }
  .carousel.news-banner :deep(.el-carousel__item img) {
    object-fit: cover;
    object-position: center center;
  }
}
</style>